// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const rerunInNoteOneMax = 4000;

export const RerunIn = zod.object({
  "note": zod.union([zod.string().max(rerunInNoteOneMax),zod.null()]).optional()
});

export type RerunIn = zod.input<typeof RerunIn>;
export type RerunInOutput = zod.output<typeof RerunIn>;
